import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * WidgetEmptyState - Reusable empty state component for widgets
 * Provides consistent styling for when widgets have no data to display
 * 
 * Note: Pass a FontAwesome icon object directly, not a string name.
 * Example: icon={faChartSimple} where faChartSimple is imported from @fortawesome/pro-light-svg-icons
 */
const WidgetEmptyState = ({ 
  title = "No data available", 
  description = "Try adjusting your filters or date range",
  icon = null,
  className = ""
}) => {
  return (
    <div className={`h-full w-full flex items-center justify-center ${className}`}>
      <div className="text-center py-8 px-4">
        {icon && (
          <div className="mb-3">
            <FontAwesomeIcon
              icon={icon}
              className="text-text-2 text-3xl"
            />
          </div>
        )}
        <div className="text-text-2 text-lg font-semibold mb-2">
          {title}
        </div>
        {description && (
          <div className="text-text-2 text-sm">
            {description}
          </div>
        )}
      </div>
    </div>
  );
};

WidgetEmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.object,
  className: PropTypes.string
};

export default WidgetEmptyState;
